import {
  Directive,
  HostBinding,
  ElementRef,
  Input,
  Renderer2,
  HostListener,
} from '@angular/core';

let uid = 0;

@Directive({
  selector:
    '[pgDropDownItem], pg-drop-down-item, [gritDropDownItem], grit-drop-down-item',
  exportAs: 'pgDropDownItem, gritDropDownItem',
})
export class PgDropDownItemDirective {
  @HostBinding('class.pg-drop-down-item')
  _classDropDown = true;

  @HostBinding('class.is-focused')
  isFocused = false;

  @Input()
  value: any;
  @Input()
  searchableTerms: string[] = [];

  @Input('id')
  id = `pg-drop-down-${uid++}`;

  get displayText() {
    return this.elementRef.nativeElement.textContent;
  }

  constructor(public elementRef: ElementRef, private _renderer: Renderer2) {}

  @HostListener('click')
  onClick() {}

  @HostListener('mouseover')
  onMouseOver() {}
}
